import { render } from "./CompletedCard.vue?vue&type=template&id=87e208fa&scoped=true"
import script from "./CompletedCard.vue?vue&type=script&lang=js"
export * from "./CompletedCard.vue?vue&type=script&lang=js"

import "./CompletedCard.vue?vue&type=style&index=0&id=87e208fa&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e208fa"]])

export default __exports__